import * as React from 'react';

import gql from 'graphql-tag';
import { Query } from 'react-apollo';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import Switch from '@material-ui/core/Switch';

import VisibilityIcon from '@material-ui/icons/Visibility';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';




import Rest from "../../../../services/Rest";

import "./TableBookstores.scss";

// tslint:disable-next-line:no-empty-interface
export interface ITableBookstoresPros {
    receiveBookstoreToEdit(bookstore: any): void
}

export interface ITableBookstores {
  count: number,
  limit: number,
  offset: number,
  openDialogMoreInfo: boolean,
  page: number,
  rowToView: any,
  rows?: any,
  store: {
    address: string,
    cnpj: string,
    county: string,
    group_id: number,
    group_name: string,
    id: number,
    name: string,
    preprd_id: number,
    state: string,
    zipcode: string
}
}

const QUERY_SEARCH_BOOKSTORE = gql`
    query getBookstoreRegister($customFilter:  BookstoreFilter) {
        getBookstoreRegister(bookstoreFilter: $customFilter) {
            address,cnpj,county,deletedat, group_id,group_name,id,name, preprd_id,state,zipcode
        }
    }
`;

const QUERY_INATIVATE_BOOKSTORES = ` query inativateBookstoreRegister($customFilter:  BookstoreFilter) { inativateBookstoreRegister(bookstoreFilter: $customFilter) } `;


export class TableBookstores
  extends React.Component<ITableBookstoresPros, ITableBookstores> {

    constructor(props: ITableBookstoresPros) {
        super(props);
    
        this.state = {
            count: 10,
            limit: 10,
            offset: 0,
            openDialogMoreInfo: false,
            page: 0,
            rowToView: {},
            rows: [],
            store: {
                address: '',
                cnpj: '',
                county: '',
                group_id: 0,
                group_name: '',
                id: 0,
                name: '',
                preprd_id: 0,
                state: '',
                zipcode: ''
            }
        }

        this.handleChangePage = this.handleChangePage.bind(this);
    }

    public changeState = (store:any) => {
        this.setState( {store} );
    }

    public inativateItem (row : any) {

        const user = {
            "customFilter" : {
                deletedat: row.deletedat,
                id: row.id,
                preprd_id: row.preprd_id
            }
        };

        const body = {
            "operationName":"",
            "query":QUERY_INATIVATE_BOOKSTORES,
            "variables": user
        };
        
        Rest.GraphqlPOST(body)
            .then( data  => {
                if(row.deletedat != null && row.deletedat !== undefined && row.deletedat !== "" ) {
                    row.deletedat = null;
                } else {
                    row.deletedat = "ok";
                }
                this.forceUpdate();
                
            });
    }

    public render() {

        const filter = {
            "customFilter" : {
                address: this.state.store.address,
                cnpj: this.state.store.cnpj,
                county: this.state.store.county,
                group_id: this.state.store.group_id,
                group_name: this.state.store.group_name,
                id: this.state.store.id,
                name: this.state.store.name,
                state: this.state.store.state,
                zipcode: this.state.store.zipcode
            }
        };

        return (
            <Query query={QUERY_SEARCH_BOOKSTORE} variables={filter} partialRefetch={true} fetchPolicy="no-cache" >
                {({ loading, error, data}) => {
                    return (
                        <div>

                            <Dialog
                                open={this.state.openDialogMoreInfo}
                                onClose={this.handleCloseDialogMoreInfo}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">
                                    {this.state.rowToView.name}
                                </DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        <Grid container={true} spacing={24}>
                                            <Grid item={true} xs={6}>
                                                <Typography variant="body1">CNPJ: {this.state.rowToView.cnpj}</Typography>
                                            </Grid>
                                            <Grid item={true} xs={6}>
                                                <Typography variant="body1">Grupo: {this.state.rowToView.group_name}</Typography>
                                            </Grid>

                                            <Grid item={true} xs={6}>
                                                <Typography variant="body1">Cep: {this.state.rowToView.zipcode}</Typography>
                                            </Grid>

                                            <Grid item={true} xs={6}>
                                                <Typography variant="body1">Endereço: {this.state.rowToView.address}</Typography>
                                            </Grid>

                                            <Grid item={true} xs={6}>
                                                <Typography variant="body1">Município: {this.state.rowToView.county}</Typography>
                                            </Grid>

                                            <Grid item={true} xs={3}>
                                                <Typography variant="body1">Estado: {this.state.rowToView.state} </Typography>
                                            </Grid>
                                        </Grid>
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={this.handleCloseDialogMoreInfo} color="primary">
                                        Fechar
                                    </Button>
                                </DialogActions>
                            </Dialog>
                            
                            {loading ? <LinearProgress /> : 
                                <div>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell  >Ordem</TableCell>
                                                <TableCell  >Livraria</TableCell>
                                                <TableCell  >CNPJ</TableCell>
                                                <TableCell  >Grupo</TableCell>
                                                <TableCell  >Ativo</TableCell>
                                                <TableCell  >Ação</TableCell>
                                            </TableRow>
                                        </TableHead>
                        
                                        {this.getTableBody(error, data)}
                                    </Table>
                                    <TablePagination
                                        component="div"
                                        page={this.state.page}
                                        count={data && data.getBookstoreRegister ? data.getBookstoreRegister.length : this.state.count}
                                        rowsPerPage={this.state.limit}
                                        rowsPerPageOptions={[]}
                                        backIconButtonProps={{
                                            'aria-label': 'Previous Page',
                                        }}
                                        nextIconButtonProps={{
                                            'aria-label': 'Next Page',
                                        }}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={undefined}
                                    />
                                </div>
                            }
                            
                        </div>
                    );
                }}
            </Query>
            
        );
    }

    public getTableBody (error: any, data:any) {
         
        if(!error && data && data.getBookstoreRegister) {

            return (
                <TableBody>
                    {
                        this.paginacaoVirtual(data.getBookstoreRegister).map((row: any, key: number) => {
                        return (
                            <TableRow key={key}>
                                <TableCell >{ 1 + key + (this.state.page * this.state.limit) }</TableCell>
                                <TableCell  component="th" scope="row">{row.name}</TableCell>
                                <TableCell  >{row.cnpj}</TableCell>
                                <TableCell  >{row.group_name}</TableCell>
                                <TableCell >
                                    <Switch
                                        checked={row.deletedat==null || row.deletedat===undefined || row.deletedat === ""}
                                        onChange={this.inativateItem.bind(this, row)}
                                        value="store.deletedat"
                                        color="primary"
                                    />
                                </TableCell>
                                <TableCell  className="actionColumn">
                                    <IconButton className="editAction"  onClick={this.editItem.bind(this, row)} aria-label="Editar">
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton className="viewAction" color="primary" onClick={this.handleOpenDialogMoreInfo.bind(this, row)} aria-label="Editar">
                                        <VisibilityIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        );
                        })
                    }
                </TableBody>
            );
        } else {
            return null;
        }
    }

    public editItem (row : any) {
        this.props.receiveBookstoreToEdit(row);
    };

    /**
     * View Data
     * 
     * Methods that manager the dialog that show details from row selected
     */
    private handleOpenDialogMoreInfo = (row : any) => {
        this.setState({ openDialogMoreInfo: true, rowToView: row });
    };

    private handleCloseDialogMoreInfo = () => {
        this.setState({ openDialogMoreInfo: false, rowToView: {} });
    };

    /**
     * Pagination
     * 
     * Methods add pagination to the result table
     * 
     */
    private paginacaoVirtual = (bookstoreAnalysisData: any[]) => {
        const start = this.state.offset;
        const end = start + 10;
        return bookstoreAnalysisData.slice(start, end)
    }

    private handleChangePage(ev: any, pageParam: number) {

        if (pageParam <= this.state.page) {
            this.setState({
                offset: pageParam * 10 <= 0 ? 0 : pageParam * 10,
                page: pageParam,
            });
        } else {
            this.setState({
                offset: pageParam * 10,
                page: pageParam,
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/component/administration/registers/bookstores/TableBookstores.tsx